import { createAction, props } from "@ngrx/store";
import { LetterOfAuthorizationResponse } from "../models/pdf/LetterOfAuthorizationResponse";
import { Acknowledgement } from "../models/review-page/ReviewPage";
import { PageTypes } from "../../shared/utilities/Constants";

export const updateAcknowledgement = createAction(
    '[Review Page] Update acknowledgement',
    props<{ acknowledgement: Acknowledgement }>()
);

export const editClicked = createAction(
    '[Review Page] Edit clicked'
);

export const cancelClicked = createAction(
    '[Review Page] Cancel clicked'
);

export const loadConfirmationPage = createAction(
    '[Review Page] Load the confirmation page'
);

export const submitClicked = createAction(
    '[Review Page] Submit clicked'
);

export const generateAuthorizationForm = createAction( 
    '[Review Page - LOA] Generate authorization form',
    props<{ source: PageTypes, includeCreateSloaDetails?: boolean }>()
);

export const generateAuthorizationFormSuccessful = createAction(
    '[Review page - LOA]  Generate authorization form successful',
    props<{ response: LetterOfAuthorizationResponse }>()
);

export const generateMultipleAuthorizationForms = createAction( 
    '[Review Page - LOA] Generate authorization forms for multiple transactions',
    props<{ source: PageTypes, toAccounts: string[] }>()
);

export const generateAuthorizationFormsSuccessful = createAction(
    '[Review page - LOA]  Generate authorization form successful',
    props<{ responses: LetterOfAuthorizationResponse[] }>()
);

export const generateAuthorizationFormsFail = createAction(
    '[Review Page - LOA] Error generating form',
    props<{ errorMsg: string }>()
);

export const generateAuthorizationFormFail = createAction(
    '[Review Page - LOA] Error generating form',
    props<{ errorMsg: string }>()
);

export const clearAttentionMessage = createAction(
    '[Review Page] Clear Attention Messages'
);

export const submitAndCreateToggled = createAction(
    '[Review Page - Submit And Create] Submit and Create toggled',
    props<{ isSubmitAndCreate: boolean }>()
)

export const saveAsTemplateToggled = createAction(
    '[Review Page - Save as Template] Save as Template toggled',
    props<{ isSaveAsTemplate: boolean }>()
)

export const updateTemplateNickname = createAction(
    '[Review Page - Save as Template] Nickname updated',
    props<{ nickname: string }>()
)

export const clientAwaitingAllianceUsed = createAction(
    '[Review Page] Send email to eauth client with Awaiting Alliance setup status',
    props<{ accountId: string, customerId: string, emailAddress: string }>()
)

export const loadConfirmationPageWithoutAcknowledgeCall = createAction(
    '[Review Page] Load the confirmation page using already present data instead of call acknowledge.',
    props<{ isCondensedWireCreatePdfFlow: boolean }>()
)
